import DeviceGroupsStatApi from '@/api/device_groups_stat';

export default {
  namespaced: true,
  state: {
    item: null,
    meta: {},
    loading: false,
    error: null,
    params: {
      period: {
        from: null,
        to: null,
      }
    }
  },

  actions: {
    async getItem(ctx, params) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const id = params.id;
        const result = await DeviceGroupsStatApi.getTxStat({
          id,
          ...ctx.getters.params
        });

        ctx.commit('setItem', result.data);
      } catch (error) {
        ctx.dispatch('errors/pushError', { id: 'device_group_stat', error }, { root: true });
        ctx.commit('setError', error);
        throw error;
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    changeParams(context, params) {
      context.commit('changeParams', params);
    }
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },

    setItem(state, data) {
      state.item = data;
    },

    changeParams(state, data) {
      Object.assign(state.params, data)
    }
  },

  getters: {
    meta: state => state.meta,
    error: state => state.error,
    loading: state => state.loading,
    params: state => state.params,
    item: state => state.item
  }
};
